$(document).ready(function() {

    $('.bubbles').on('mouseenter', 'div', function() {
        var active = $(this).data('bubble');
        $('.hydra-info').attr('class', 'hydra-info ' + active);
    });
    $('.bubbles').on('mouseleave', 'div', function() {
        $('.hydra-info').attr('class', 'hydra-info');
    });
});
